import React from 'react';
import { TextField, Box } from '@mui/material';
import { FormikErrors } from 'formik';
import { ClientData } from '../../../core/api/clients/ClientModel';

interface CompanyDetailsSectionProps {
  values: Partial<ClientData>;
  errors: FormikErrors<ClientData>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  className: string;
}

export const CompanyDetailsSection: React.FC<CompanyDetailsSectionProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
  className,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '12px',
        '& .MuiInputBase-root': { width: '100%' },
        '& .MuiOutlinedInput-root': { width: '100%' },
        '& .MuiFormControl-root': { width: '100%', minHeight: '56px' }
      }}
    >
      {values.id && (
        <TextField
          className={className}
          id="id"
          type="text"
          disabled
          name="id"
          label="Įmonės ID"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={values.id}
          variant="outlined"
        />
      )}
      <TextField
        className={className}
        error={Boolean(errors.companyTitle)}
        id="companyTitle"
        type="text"
        name="companyTitle"
        label="Įmonės pavadinimas"
        fullWidth
        onChange={handleChange}
        helperText={errors.companyTitle}
        value={values.companyTitle}
        onBlur={handleBlur}
        variant="outlined"
      />
      <TextField
        className={className}
        error={Boolean(errors.companyCode)}
        id="companyCode"
        type="text"
        name="companyCode"
        label="Įmonės kodas"
        onChange={handleChange}
        fullWidth
        helperText={errors.companyCode}
        value={values.companyCode}
        onBlur={handleBlur}
        variant="outlined"
      />
      <TextField
        className={className}
        error={Boolean(errors.companyVatCode)}
        id="companyVatCode"
        type="text"
        name="companyVatCode"
        label="Įmonės PVM mokėtojo kodas"
        fullWidth
        onChange={handleChange}
        helperText={errors.companyVatCode}
        value={values.companyVatCode}
        onBlur={handleBlur}
        variant="outlined"
      />
      <TextField
        className={className}
        error={Boolean(errors.companyAddress)}
        id="companyAddress"
        type="text"
        name="companyAddress"
        label="Įmonės adresas"
        onChange={handleChange}
        fullWidth
        helperText={errors.companyAddress}
        value={values.companyAddress}
        onBlur={handleBlur}
        variant="outlined"
      />
    </Box>
  );
}; 